/**
 * 呼び出し元画面の入力情報を格納するVO
 *
 */
export class KYMW1901InputModel {

  /**
   * 画面ＩＤ
   */
  public formId: string = <string>'';

}
